import { render, staticRenderFns } from "./LiveInteractions.vue?vue&type=template&id=b638143c"
import script from "./LiveInteractions.vue?vue&type=script&lang=ts"
export * from "./LiveInteractions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports